<template>
  <div id="expertReportsView">
    <div v-if="$route.name === 'expertreports'">
      <b-col lg="8" style="padding-left: 0px;">
        <h1>{{ $t('privatePage.expert_report_header') }}</h1>
        <expert-reports-table :reports="reports"
                        :allowEdit="true"
                        v-on:beforeEditReport="beforeEditReport">
        </expert-reports-table>
        <b-button @click.stop="addReport" class="btn-secondary mt-2">{{ $t('privatePage.expert_report_add_report') }}</b-button>
      </b-col>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ExpertReportsTable from '../../components/expertreports/expertreportstable'

export default {
  name: 'expert-reports-view',
  components: {
    ExpertReportsTable
  },
  computed: {
    ...mapGetters('expertReportsModule', ['reports'])
  },
  methods: {
    ...mapActions('expertReportsModule', [
      'selectCurrentReport',
      'getReport',
      'getAllReports'
    ]),
    addReport: function() {
      this.selectCurrentReport({
        id: '',
        testMethodId: '',
        normGroupId: '',
        translations: []
      })
      this.$router.push({ path: '/private/expertreports/expertreport' })
    },
    beforeEditReport: function(report) {
      this.getReport({
        reportId: report.id
      }).then(() => {
        this.$router.push({ path: '/private/expertreports/expertreport' })
      })
    }
  },
  created() {
    this.getAllReports()
  }
}
</script>
